module.exports = __webpack_public_path__ + "static/media/lrc-line.3fec5415.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Svgs/lrc-line.svg
// module id = 829
// module chunks = 0